export default __webpack_public_path__ + "static/media/engdahldn.f0aece46.jpg";